import React from 'react'

export default function StudentsDashboard() {
  return (
    <div>StudentsDashboard</div>
  )
}
